import { render, staticRenderFns } from "./GoogleProfileIdModal.vue?vue&type=template&id=523e1b15"
import script from "./GoogleProfileIdModal.vue?vue&type=script&lang=js"
export * from "./GoogleProfileIdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports